import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges, signal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { UserCompanyService } from 'src/app/services/userCompany.service';
import { MareLoaderModule } from '@mare-common/ngx-mare-loader';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { OverviewComponent } from './components/overview/overview.component';
import { CompanyIdentityComponentsModule } from './company-identity-components.module';
import { CompanyBalanceComponent } from './components/company-balance/company-balance.component';

@Component({
  selector: 'app-company-identity',
  templateUrl: './company-identity.component.html',
  styleUrls: ['./company-identity.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatListModule,
    TranslateModule,
    SharedModule,
    MareLoaderModule,
    MatProgressSpinnerModule,
    CompanyIdentityComponentsModule,
    OverviewComponent,
    CompanyBalanceComponent,
    
  ]
})
export class CompanyIdentityComponent implements OnInit{

  @Input() company: any;
  @Input() ateco!: string;
  @Input() piva!: string | number;
  @Input() chartConfig!: any;
  missingCompanyData$ = signal<boolean>(false);

  constructor(private userCompanyService: UserCompanyService) { }
  ngOnInit(): void {
    console.log('oninit');
    if (!this.company) {
     
       this.userCompanyService.userCompany$.subscribe((res: any) => {
        if (res.company?.eureso_overview?.localFinancialStatements) {
          this.company = res.company?.eureso_overview;
        } else {
          this.missingCompanyData$.set(true)
        }
        console.log('company', this.company)
      })
    } 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['company']) {
      this.company = changes['company'].currentValue
    }
    if (changes['ateco']) {
      this.ateco = changes['ateco'].currentValue;
    }
    if (changes['piva']) {
      this.piva = changes['piva'].currentValue;
    }
    console.log('onchanges')
  }

  // ngOnDestroy(): void {
  //   console.log('ondestroy')
  //   this.userCompanyService.companyEureso$.unsubscribe();
  // }

  

}
